import { IAdditionalValidationError } from './withAdditionalValidationContext';

export enum WithAdditionalValidationActions {
	SET_MAIN_FORM_VALIDATION_FAIL = 'SET_MAIN_FORM_VALIDATION_FAIL',
	ADD_ADDITIONAL_VALIDATION_ERROR = 'ADD_ADDITIONAL_VALIDATION_ERROR',
	REMOVE_ADDITIONAL_VALIDATION_ERROR = 'REMOVE_ADDITIONAL_VALIDATION_ERROR',
	REMOVE_ALL_ADDITIONAL_VALIDATION_ERRORS_IN_BLOCK = 'REMOVE_ALL_ADDITIONAL_VALIDATION_ERRORS_IN_BLOCK',
}

interface ISetMainFormValidationFail {
	type: WithAdditionalValidationActions.SET_MAIN_FORM_VALIDATION_FAIL;
	payload: {
		failStatus: boolean;
	};
}

interface IAddAdditionalValidationError {
	type: WithAdditionalValidationActions.ADD_ADDITIONAL_VALIDATION_ERROR;
	payload: {
		validationError: IAdditionalValidationError;
	};
}

interface IRemoveAdditionalValidationError {
	type: WithAdditionalValidationActions.REMOVE_ADDITIONAL_VALIDATION_ERROR;
	payload: {
		errorId: string;
	};
}

interface IRemoveAllAdditionalValidationErrorsInBlock {
	type: WithAdditionalValidationActions.REMOVE_ALL_ADDITIONAL_VALIDATION_ERRORS_IN_BLOCK;
	payload: {
		blockId: string;
	};
}

export type TWithAdditionalValidationAction =
	| ISetMainFormValidationFail
	| IAddAdditionalValidationError
	| IRemoveAdditionalValidationError
	| IRemoveAllAdditionalValidationErrorsInBlock;
